import { render, staticRenderFns } from "./transactionAlert.vue?vue&type=template&id=0c52655c&"
import script from "./transactionAlert.vue?vue&type=script&lang=js&"
export * from "./transactionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports